import { render, staticRenderFns } from "./FreeLineSettings.vue?vue&type=template&id=cae2b806&scoped=true"
import script from "./FreeLineSettings.vue?vue&type=script&lang=ts"
export * from "./FreeLineSettings.vue?vue&type=script&lang=ts"
import style0 from "./FreeLineSettings.vue?vue&type=style&index=0&id=cae2b806&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae2b806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cae2b806')) {
      api.createRecord('cae2b806', component.options)
    } else {
      api.reload('cae2b806', component.options)
    }
    module.hot.accept("./FreeLineSettings.vue?vue&type=template&id=cae2b806&scoped=true", function () {
      api.rerender('cae2b806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reminder-layout-editor/FreeLineSettings.vue"
export default component.exports